/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorFallback from 'base/components/labrador/Fallback';

export const DynamicLabradorFallback: typeof LabradorFallback = (props) => {
    return <ErrorBoundary><LabradorFallback {...props} /></ErrorBoundary>;
}
export type DynamicLabradorFallbackProps = PropsFromComponent<typeof LabradorFallback>;
